import { Check } from "lucide-react";
import PageHeader from "../components/sections/PageHeader";
import ServicesGrid from "../components/sections/ServicesGrid";
import CTASection from "../components/sections/CTASection";
import EditorialMarquee from "../components/sections/EditorialMarquee";
import { Reveal } from "../components/motion";
import { Eyebrow } from "../components/CTA";
import { SERVICE_HIGHLIGHTS } from "../lib/site";
import Seo from "../components/Seo";

const Services = () => {
  return (
    <div data-testid="services-page">
      <Seo
        title="Services"
        description="End-to-end manufacturing services from PAHI TECHNOCRATE: precision sheet metal, fabrication, laser cutting, CNC machining, tool room development, power press, precision bending, MIG/TIG welding, powder coating & OEM manufacturing support."
        path="/services"
      />
      <PageHeader
        eyebrow="Our Services"
        crumb="Services"
        titleLines={["Complete manufacturing", <span key="s" className="text-brand-soft">capabilities.</span>]}
        subtitle="From precision sheet metal and fabrication to CNC machining, welding and finishing — a single, reliable partner for your entire component lifecycle."
      />

      <ServicesGrid />

      <EditorialMarquee dark />

      {/* Highlights */}
      <section className="relative overflow-hidden bg-navy py-24 grain sm:py-32" data-testid="service-highlights">
        <div className="blueprint-grid absolute inset-0 opacity-40" />
        <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
          <div className="grid gap-12 lg:grid-cols-[1fr_1.4fr] lg:items-center">
            <div>
              <Eyebrow dark>Why Partner With Us</Eyebrow>
              <h2 className="mt-5 font-display text-4xl font-medium leading-tight tracking-tight text-white sm:text-5xl">
                Built for OEMs who demand more.
              </h2>
              <p className="mt-5 text-white/60">
                We combine capacity, capability and consistency — delivering manufacturing you can build a business on.
              </p>
            </div>

            <div className="grid gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/10 sm:grid-cols-2">
              {SERVICE_HIGHLIGHTS.map((h, i) => (
                <Reveal key={h} delay={(i % 2) * 0.05}>
                  <div className="flex h-full items-center gap-3 bg-ink p-5" data-testid={`highlight-${i}`}>
                    <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand text-white">
                      <Check className="h-4 w-4" />
                    </span>
                    <span className="font-display text-sm font-medium text-white">{h}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
};

export default Services;
